var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2494_32463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.31977 7.68006L0.579766 15.4201C0.209766 15.0701 0.00976562 14.5901 0.00976562 14.0701V1.93006C0.00976562 1.40006 0.219766 0.920059 0.599766 0.560059L8.31977 7.68006Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0103 8.00004C15.0103 8.70004 14.6303 9.32004 14.0003 9.67004L11.8003 10.89L9.07031 8.37004L8.32031 7.68004L11.2103 4.79004L14.0003 6.33004C14.6303 6.68004 15.0103 7.30004 15.0103 8.00004Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31961 7.68002L0.599609 0.560017C0.699609 0.460017 0.829609 0.370017 0.959609 0.290017C1.58961 -0.0899828 2.34961 -0.0999829 2.99961 0.260017L11.2096 4.79002L8.31961 7.68002Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8001 10.8899L3.00008 15.7399C2.69008 15.9199 2.34008 15.9999 2.00008 15.9999C1.64008 15.9999 1.28008 15.9099 0.960078 15.7099C0.821213 15.6304 0.693444 15.5329 0.580078 15.4199L8.32008 7.67993L9.07008 8.36993L11.8001 10.8899Z",
    fill: "#F44336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2494_32463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/playStore.619a01c3b126a1e7502a7fc1b97441da.svg";
export { ForwardRef as ReactComponent };